import { withRouter } from 'react-router-dom';
import { Fragment, useMemo, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useHistory } from "react-router-dom";

import List from '@material-ui/core/List';
import ListItem from '@material-ui/core/ListItem';
import ListItemIcon from '@material-ui/core/ListItemIcon';
import Box from '@material-ui/core/Box';
import { makeStyles, useTheme } from '@material-ui/core/styles';
import Backdrop from "@material-ui/core/Backdrop";
import CircularProgress from "@material-ui/core/CircularProgress";
import Typography from "@material-ui/core/Typography";
import Button from "@material-ui/core/Button";
import Tooltip from '@material-ui/core/Tooltip';

import { invokeGetService, toggleRightDrawer } from "../../../store/global/actions";
import { getRightDrawerStatus, getCodeEditStatus, getBlueprintDetails } from '../../../store/global/selectors';
import { getTransaction, getSelectedTransactions, getAllTransactions } from "../../../store/constructs/transactions/selectors";
import { getLuaEditorData } from "../../../store/constructs/handlers/selectors";
import { checkLuaFileDefs } from "../../../services/raphaelJsService";
import { resetBluePrint } from '../../../store/blueprint/actions';
import Dialog from "../../../components/atoms/dialog";
import { UserDetailsDropDown } from '../../../components/molecules/user/UserDropDown';
import { clearAll } from "../../../store/blueprint/actions";
import { invokePostService, setIsDocumentClicked } from "../../../store/global/actions";
import ConfigurationsAlert from '../alerts/ConfigurationsAlert';
import { Badge } from '@material-ui/core';
import { useEffect } from 'react';
import { getLoggedInUserId } from '../../../store/auth/selectors';



const useStyles = makeStyles((theme) => ({
    root: {
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'space-between',
        height: '100vh',
        float: 'left',


    },
    selectedIconButton: {
        backgroundColor: '#48566a',
    },
    image: {
        width: 44,
        height: 44
    },
    icon: {
        width: 38,
        height: 38
    },
    expandIcon: {
        position: 'absolute',
        top: '50%',
        right: 0,
        transform: 'translateY(-50%)',
        // backgroundColor: '#fff',
        width: 25,
        height: 15,
        // marginLeft: '-30px',
        zIndex: 20,
        // left: 50
    },
    list: {
        paddingTop: 0,
        paddingBottom: 0,
    },
    backdrop: {
        zIndex: 2000,
        color: "#fff",
    },
    listItem: {
        '&:hover': {
            backgroundColor: '#3f4e5c', // set your desired hover color
        },
    },
    infoBadge: {
        backgroundColor: '#3f51b5', 
        color: '#fff',
        left: 16,
        top: -16,
        width: 18,
        height: 18,
        fontSize: '0.7rem'
    },
    errorBadge: {
        backgroundColor: '#f44336', 
        color: '#fff',
        left: 16,
        top: -16,
        width: 18,
        height: 18,
        fontSize: '0.7rem'
    },

}));

const BlueprintDrawerMenu = (props) => {



    const classes = useStyles();
    const theme = useTheme();
    const dispatch = useDispatch();
    const history = useHistory();
    const [, , slug, id, tag] = history.location.pathname.split("/");
    const currentTag = tag;
    const mainTag = tag;

    const [selectedIndex, setSelectedIndex] = useState(10);
    const [openBackDrop, setOpenBackDrop] = useState(false);
    const [switchScreenTag, setSwitchScreenTag] = useState("");
    const [luaDialog, setLuaDialog] = useState(false);
    const [codeEditorView, setCodeEditorView] = useState(false);
    const [openUserPop, setopenUserPop] = useState(null);
    const [openConfigurations, setOpenConfigurations] = useState(false);
    const [showLatestAlert, setShowLatestAlert] = useState(false);

    const loggedInUserId = useSelector(getLoggedInUserId);
    const getLuaFile = useSelector(getLuaEditorData);
    const transactionList = useSelector(getTransaction);
    const selectedTransactions = useSelector(getSelectedTransactions);
    const alltransactions = useSelector(getAllTransactions);
    const drawerStatus = useSelector(getRightDrawerStatus);
    const codeEditStatus = useSelector(getCodeEditStatus);
    const blueprintDetails = useSelector(getBlueprintDetails) || {};

    const isBlueprintOwner = useMemo(() => {
        return Boolean(loggedInUserId === blueprintDetails?.user_id);
    }, [blueprintDetails, loggedInUserId]);

    useEffect(() => {
        isBlueprintUsingLatestPlatformSchema();
    }, [blueprintDetails])


    const isBlueprintUsingLatestPlatformSchema = () => {
        const platformSchemaLatestSeen = localStorage.getItem(`platformSchemaLatestSeen_${id}`);
        
        dispatch(invokeGetService('checkBlueprintOnLatestSchema', [])).then((response) => {
            if (response?.status === true && response.data) {
                if (isBlueprintOwner && response.data.isLatestPlatformSchema === false && response.data.latestPlatformSchemaVersion && (platformSchemaLatestSeen === null || (platformSchemaLatestSeen !== response.data.latestPlatformSchemaVersion))) {
                    setShowLatestAlert(true);
                } else {
                    setShowLatestAlert(false);
                }
            }
        });
    }


    const toggleCodeEditor = () => setCodeEditorView((prev) => !prev);

    const toggleLuaDialog = () => setLuaDialog((prev) => !prev);


    const handleListItemClick = (event, index) => {
        setSelectedIndex(index);
    };

    const handleBackDropToggle = () => {
        setOpenBackDrop((prev) => !prev);
    };


    const exitTheBuilder = () => {
        if (codeEditStatus) {
            dispatch(setIsDocumentClicked());
            return;
        }
        // toogleMenuDrawer();
        handleBackDropToggle();
        dispatch(invokePostService('removeLocks', {}, []));
        history.push(`/`);
        dispatch(resetBluePrint());
        dispatch(clearAll()).then(async res => {
            handleBackDropToggle();
        })

    };

    const route = (tag) => {
        setSwitchScreenTag(tag);
        dispatch(invokePostService('removeLocks', {}, []));
        if(drawerStatus === true) {
            dispatch(toggleRightDrawer());
        }

        if (currentTag !== "transaction") {
            tag = tag.split(" ").join("_").toLowerCase();
            history.push(`/blueprint/${slug}/${id}/${tag}`);
            //   toogleMenuDrawer();
        } else {
            const checkHandlersAdded = checkLuaFileDefs(
                getLuaFile,
                transactionList,
                selectedTransactions,
                alltransactions,
            );
            if (checkHandlersAdded === false) {
                toggleLuaDialog();
            } else {
                tag = tag.split(" ").join("_").toLowerCase();
                history.push(`/blueprint/${slug}/${id}/${tag}`);
                // toogleMenuDrawer();
            }
        }
    };




    const handleClickUserPop = (event) => {
        setopenUserPop(event.currentTarget);
    }

    const userPopOverClose = () => {
        setopenUserPop(null);
        setSelectedIndex(10);
    };
    
    const onClickMenu = (screen) => {
        if (codeEditStatus) {
            dispatch(setIsDocumentClicked());
            return;
        }
        route(screen);
    }
    return (
        <>
            {openUserPop && <UserDetailsDropDown anchorEl={openUserPop} handleClose={userPopOverClose} />}
            {openConfigurations && <ConfigurationsAlert onClose={() => setOpenConfigurations(false)} />}
            <Box id={"blueprint_sidebar_menu"} flexGrow={1} >
                <List className={classes.list} >
                    <Tooltip 
                        title="Dashboard" 
                        PopperProps={{
                              modifiers: {
                                offset: {
                                  enabled: true,
                                  offset: '0, -10', // Adjust the values as needed
                                },
                              },
                            }}
                        arrow
                        placement="left"
                    >
                        <ListItem
                            button
                            id="exitToDashboard"
                            onClick={(event) => { exitTheBuilder() }}
                            style={{ marginTop: 64, background: selectedIndex == 0 ? '#ffff00' : '', justifyContent: 'center' }}
                            //selected={selectedIndex === 0}
                            className={classes.listItem}
                            data-ui-tour-id='sb-dashboard-btn'
                        >

                            <ListItemIcon style={{ minWidth: 10 }}>
                                <img src={`${process.env.PUBLIC_URL}/ide_icons/dashboard_color.svg`} className={classes.image} />
                                {/* {selectedIndex == 0 && <img src={`${process.env.PUBLIC_URL}/ide_icons/dashboard_dark.svg`} className={classes.image} />} */}
                            </ListItemIcon>
                        </ListItem>
                    </Tooltip>

                    <Tooltip 
                        title="System Model"  
                        PopperProps={{
                              modifiers: {
                                offset: {
                                  enabled: true,
                                  offset: '0, -10', // Adjust the values as needed
                                },
                              },
                            }}
                        arrow 
                        placement="left"
                    >
                        <ListItem
                            button
                            id="system_model"
                            onClick={(event) => { onClickMenu('system-model') }}
                            // selected={selectedIndex === 1}
                            selected={mainTag == 'system-model'}
                            style={{ background: mainTag == 'system-model' ? '#ffff00' : '', justifyContent: 'center' }}
                            className={classes.listItem}
                            data-ui-tour-id='sb-system-model-btn'

                        >
                            <ListItemIcon style={{ minWidth: 10 }}>
                                {mainTag != 'system-model' && <img src={`${process.env.PUBLIC_URL}/ide_icons/systemmodel_color.svg`} className={classes.image} />}
                                {mainTag == 'system-model' && <img src={`${process.env.PUBLIC_URL}/ide_icons/systemmodel_dark.svg`} className={classes.image} />}
                            </ListItemIcon>

                        </ListItem>
                    </Tooltip>

                   
                    <Tooltip 
                        title="Assets" 
                        PopperProps={{
                           modifiers: {
                             offset: {
                               enabled: true,
                               offset: '0, -10', // Adjust the values as needed
                             },
                           },
                         }}
                        arrow 
                        placement="left"
                    >
                        <ListItem
                            button
                            id="assets"
                            onClick={(event) => { onClickMenu('assets'); }}
                            // selected={selectedIndex === 4}
                            selected={mainTag == 'assets'}
                            style={{ marginTop: 'auto', flex: 1, background: mainTag == 'assets' ? '#ffff00' : '', justifyContent: 'center' }}
                            className={classes.listItem}
                            data-ui-tour-id='sb-assets-btn'

                        >
                            <ListItemIcon style={{ minWidth: 10 }}>
                                {mainTag != 'assets' && <img src={`${process.env.PUBLIC_URL}/ide_icons/assets_color.svg`} className={classes.image} />}
                                {mainTag == 'assets' && <img src={`${process.env.PUBLIC_URL}/ide_icons/assets_dark.svg`} className={classes.image} />}
                            </ListItemIcon>

                        </ListItem>
                    </Tooltip>

                    <Tooltip 
                        title="Team"
                        PopperProps={{
                            modifiers: {
                              offset: {
                                enabled: true,
                                offset: '0, -10', // Adjust the values as needed
                              },
                            },
                          }}
                         arrow 
                         placement="left"
                    >
                        <ListItem
                            button
                            id="teams"
                            onClick={(event) => { onClickMenu('teams'); }}
                            // selected={selectedIndex === 4}
                            selected={mainTag == 'teams'}
                            style={{ marginTop: 'auto', flex: 1, background: mainTag == 'teams' ? '#ffff00' : '', justifyContent: 'center' }}
                            className={classes.listItem} assets
                            data-ui-tour-id='sb-team-btn'

                        >
                            <ListItemIcon style={{ minWidth: 10 }}>
                                {mainTag != 'teams' && <img src={`${process.env.PUBLIC_URL}/ide_icons/teams_color.svg`} className={classes.image} />}
                                {mainTag == 'teams' && <img src={`${process.env.PUBLIC_URL}/ide_icons/teams_dark.svg`} className={classes.image} />}
                            </ListItemIcon>

                        </ListItem>
                    </Tooltip>

                    <Tooltip 
                        title="Platform Schema"
                        PopperProps={{
                            modifiers: {
                              offset: {
                                enabled: true,
                                offset: '0, -10', 
                              },
                            },
                          }}
                         arrow 
                         placement="left"
                    >
                        <ListItem
                            button
                            id="platform_schema"
                            onClick={(event) => { onClickMenu('platform-schema'); }}
                            selected={mainTag === 'platform-schema'}
                            style={{ marginTop: 'auto', flex: 1, background: mainTag === 'platform-schema' ? '#ffff00' : '', justifyContent: 'center' }}
                            className={classes.listItem} assets
                            data-ui-tour-id='sb-platformschema-btn'

                        >
                            <Tooltip
                                title={
                                    (blueprintDetails.slug && !blueprintDetails.platformSchemaVersion)
                                      ? 'Platform schema not configured'
                                      : 'Platform schema update available'
                                }
                                arrow
                                placement="right"
                                disableHoverListener={!showLatestAlert}
                            >
                                <Badge id="platform_schema_badge" classes={{badge: (blueprintDetails.slug && !blueprintDetails.platformSchemaVersion) ? classes.errorBadge : classes.infoBadge }} badgeContent={"!"} invisible={!showLatestAlert}>
                                
                                </Badge>
                            </Tooltip>
                            <ListItemIcon style={{ minWidth: 10 }}>
                                    {mainTag !== 'platform-schema' && <img src={`${process.env.PUBLIC_URL}/ide_icons/platform_schema_color.svg`} className={classes.icon} />}
                                    {mainTag === 'platform-schema' && <img src={`${process.env.PUBLIC_URL}/ide_icons/platform_schema_dark.svg`} className={classes.icon} />}
                            </ListItemIcon>
                        </ListItem>
                    </Tooltip>

                </List>


            </Box>
            <Box >

                <List className={classes.list}>
                    
                    <Tooltip 
                        title="Configurations"
                        PopperProps={{
                            modifiers: {
                              offset: {
                                enabled: true,
                                offset: '0, -10', // Adjust the values as needed
                              },
                            },
                          }}
                         arrow 
                         placement="left"
                    >
                        <ListItem
                            button
                            id="configurations"
                            onClick={() => setOpenConfigurations(true)}
                            style={{ marginTop: 'auto', flex: 1, justifyContent: 'center' }}
                            className={classes.listItem}
                            data-ui-tour-id='sb-configuration-btn'
                        >
                            <ListItemIcon style={{ minWidth: 10 }}>
                                <img src={`${process.env.PUBLIC_URL}/ide_icons/deploy_color.svg`} className={classes.image} />
                            </ListItemIcon>
                        </ListItem>
                    </Tooltip>
                    <Tooltip 
                        title="Documentation"
                        PopperProps={{
                            modifiers: {
                              offset: {
                                enabled: true,
                                offset: '0, -10', // Adjust the values as needed
                              },
                            },
                          }}
                         arrow 
                         placement="left"
                    >
                        <ListItem
                            button
                            id="documentation"
                            onClick={() => window.open('/docs/getting-started/', '_blank')}
                            style={{ marginTop: 'auto', flex: 1, justifyContent: 'center' }}
                            className={classes.listItem}
                        >
                            <ListItemIcon style={{ minWidth: 10 }}>
                                <img src={`${process.env.PUBLIC_URL}/ide_icons/documentation_info.svg`} className={classes.image} />
                            </ListItemIcon>
                        </ListItem>
                    </Tooltip>

                    <Tooltip 
                        title="User" 
                        PopperProps={{
                           modifiers: {
                             offset: {
                               enabled: true,
                               offset: '0, -10', // Adjust the values as needed
                             },
                           },
                         }}
                        arrow 
                        placement="left"
                    >
                        <ListItem
                            button
                            id="user"
                            onClick={(event) => { handleListItemClick(event, 5); handleClickUserPop(event) }}
                            selected={selectedIndex === 5}
                            style={{ marginTop: 'auto', flex: 1, background: selectedIndex == 5 ? '#ffff00' : '', justifyContent: 'center' }}
                            data-ui-tour-id='sb-user-btn'
                        >
                            <ListItemIcon style={{ minWidth: 20 }}>
                                {selectedIndex !== 5 && <img src={`${process.env.PUBLIC_URL}/ide_icons/user_color.svg`} className={classes.image} />}
                                {selectedIndex === 5 && <img src={`${process.env.PUBLIC_URL}/ide_icons/user_dark.svg`} className={classes.image} />}
                            </ListItemIcon>

                        </ListItem>
                    </Tooltip>
                </List>
            </Box>

            <Backdrop
                className={classes.backdrop}
                open={openBackDrop}
                onClick={handleBackDropToggle}
            >
                <CircularProgress size={30} color="inherit" />

                <Typography style={{ marginLeft: 20 }} variant="h5" color="#fff">Saving blueprint..</Typography>
            </Backdrop>

            <LuaDialog
                luaDialog={luaDialog}
                handleClose={toggleLuaDialog}
                // toggleMenuDrawer={toogleMenuDrawer}
                tag={switchScreenTag}
                id={id}
                toggleCodeEditor={toggleCodeEditor}
            />
        </>

    )
}

export default withRouter(BlueprintDrawerMenu);


const LuaDialog = ({
    luaDialog,
    handleClose,
    toggleMenuDrawer,
    tag,
    id,
    toggleCodeEditor,
}) => {
    const history = useHistory();

    const onActionComplete = () => {
        handleClose();
        // toggleMenuDrawer();
        toggleCodeEditor();
    };

    const onCancel = () => {
        handleClose();
        tag = tag.split(" ").join("_").toLowerCase();
        history.push(`/blueprint/${id}/${tag}`);
        //toggleMenuDrawer();
    };
    return (
        <div>
            <Dialog
                title={"Alert!"}
                handleClose={handleClose}
                open={luaDialog}
                actions={
                    <>
                        <Button
                            onClick={onCancel}
                            color="primary"
                            variant="outlined"
                            style={{ marginLeft: 10 }}
                        >
                            No
                        </Button>
                        <Button
                            onClick={onActionComplete}
                            color="primary"
                            variant="contained"
                            style={{ marginLeft: 10 }}
                        >
                            Yes
                        </Button>
                    </>
                }
            >
                <Fragment>
                    You have not added lua handler definitions yet. Do you want to add
                    them?
                </Fragment>
            </Dialog>
        </div>
    );
};
